import React,{useEffect,useState} from 'react'
import {TextField,Grid, Box,Button} from "@mui/material"
import PartnerWithUsState from '../../Hooks/PartnerWithUs.state'


const PartnerWithUsFive = ({ handleBack, handleComplete, partnerWithUsData, setPartnerWithUsData }) => {
  const [info,setInfo] = useState("")
  const {SavePartnerWithUs,formBusy,response,progress} = PartnerWithUsState()
 
  useEffect(() => {
   setInfo(partnerWithUsData.additional_info)
  }, [])
 
  
  const onSubmit = () => {
    
    const payload = {
      ...partnerWithUsData,
      created_at: partnerWithUsData?.created_at || partnerWithUsData?.started_from
    };
    SavePartnerWithUs(payload)
   handleComplete()
  }

  const onChange = (e)=>{
    setInfo(e.target.value)
    setPartnerWithUsData((prev) => ({ ...prev, additional_info:e.target.value }))
  }

  return (
    <div>
        
        <Grid container  style={{justifyContent:"center",marginTop:20}} >
            
        <Grid xs={12} sx={{textAlign:"left",marginTop:{sm:2,xs:2}}} >
        <label>Additional Info</label>
        <TextField value={info} onChange={onChange} multiline minRows={3} fullWidth placeholder="Additional Info" />
        </Grid>
        </Grid>
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={onSubmit}>


          {formBusy?"Please wait...":"Submit"}
        </Button>

      </Box>
    </div>
  )
}

export default PartnerWithUsFive